/**
 * How fast the narrator writes on screen, in characters a second: the reader's own choice (Account settings), else
 * the learned pace (each long hold on a reply nudges it up), else WRITE_PACE. Kept on this device only.
 */
export const WRITE_PACE = 40;
/** The learned pace stops rising here; a chosen speed may be faster. */
export const PACE_MAX = 90;
const PACE_KEY = "loom:pace";
export const PACES = [
  { label: "Slow", cps: 25 },
  { label: "Steady", cps: WRITE_PACE },
  { label: "Brisk", cps: 60 },
  { label: "Fast", cps: PACE_MAX },
  { label: "All at once", cps: 2000 },
] as const;

export function readPace(): number {
  try { const v = Number(localStorage.getItem(PACE_KEY)); return v >= 20 && v <= 2000 ? v : WRITE_PACE; } catch { return WRITE_PACE; }
}
export function savePace(cps: number): void {
  try { localStorage.setItem(PACE_KEY, String(cps)); } catch { /* per-device convenience */ }
}
